import {NgModule} from '@angular/core';

const declarationsExport: any[] = [];

@NgModule({
  declarations: [...declarationsExport],
  imports: [],
  exports: [...declarationsExport],
})
export class DirectivesModule {
}
